import {FormControl, InputLabel, MenuItem, Select, SelectChangeEvent} from '@mui/material';
import React, {useContext} from 'react';
import ZeiterfassungDashboardContext from '../../../../../Contexts/ZeiterfassungDashboardContext/ZeiterfassungDashboardContext';

function FilterUser() {
  const {availableUsers, filter, dispatchFilter, isLoading} = useContext(
    ZeiterfassungDashboardContext
  );

  // Handler for user selection change
  const handleChange = React.useCallback(
    (event: SelectChangeEvent) => {
      const newUser = event.target.value;
      dispatchFilter({
        type: 'SET_USER',
        payload: newUser,
      });
    },
    [dispatchFilter]
  );

  // If no users available or loading, disable the select
  const isDisabled = availableUsers.length === 0 || isLoading;

  return (
    <FormControl sx={{m: 1, minWidth: 250}} disabled={isDisabled}>
      <InputLabel id='user-select-label'>Mitarbeiter/-in</InputLabel>
      <Select
        labelId='user-select-label'
        id='user-select'
        value={filter.user}
        onChange={handleChange}
        label='Mitarbeiter/-in'>
        <MenuItem value=''>
          <em>Alle</em>
        </MenuItem>
        {availableUsers.map((user) => (
          <MenuItem key={user.user_id} value={user.user_id}>
            {user.fullname && user.fullname !== '' ? user.fullname : user.email}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default React.memo(FilterUser);
